import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class ConfiguracaoService extends Service {
    constructor() {
      super();
  
      this.url = env.baseIdentificacao + "configuracao";
    }

    async getEstiloPersonsonalizado(key) {
      const params = new URLSearchParams();
      params.append('key', key);

      const queryString = params.toString();
      return await this.get(`${this.url}/estilo?${queryString}`);
    }
  }
  
  export const configuracaoService = new ConfiguracaoService()
  